import React, { Suspense, useEffect, useState } from "react";
import logo from "../../Images/bg_None_Logo.png";
import { useSelector, useDispatch } from "react-redux";
import { CreateUniqId, useScrollToTop } from "../../Utility";
import { useNavigate } from "react-router-dom";
import { RenderLoadingSpinnerInImageTag } from "./Helper";
import { displayMyQuery } from "../../features/LoggedInComponents/SetDisplayCollectionMyQueryOrDocumentSlice";
import {
  getDataBaseListWithCollection,
  setDefault_GetDatabaseList,
} from "../../features/Api/Dashboard/getDataBaseList";
import { setRefreshTokenInValid } from "../../features/UserLoginStatusSlice";
import { setDisplayAlertForRefreshInValid } from "../../features/DisplayAlertRefreshInValidSlice";

// * import method different because its a lazy load import
const OnSelectDocument = React.lazy(() =>
  import(`./Components/Dashboard/DatabaseAndCollectionDetails/OnSelectDocument`)
);
const OnSelectDatabase = React.lazy(() =>
  import(`./Components/Dashboard/DatabaseAndCollectionDetails/onSelectDatabase`)
);
const OnSelectMyQueries = React.lazy(() =>
  import(
    `./Components/Dashboard/DatabaseAndCollectionDetails/OnSelectMyQueries`
  )
);
const AccordionDataBaseList = React.lazy(() =>
  import(
    "./Components/Dashboard/DatabaseAndCollectionList/AccordionDataBaseList"
  )
);
const CreateCollectionOrDatabaseModal = React.lazy(() =>
  import(`./Components/Dashboard/Modals/CreateCollectionOrDatabaseModal`)
);

export const Dashboard = () => {
  // * At the top of the page.
  useScrollToTop();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // * Start ***Enable Dark Mode Feature***
  const darkModeState = useSelector((state) => state.setMode).darkMode;
  const bgCardDynamic = useSelector((state) => state.setMode).css
    ?.cardBackground;
  const textColorDynamic = useSelector((state) => state.setMode).css?.textColor;
  const backGroundDynamic = useSelector((state) => state.setMode).css
    ?.backGroundColor;
  const [selectedAccordionId, setSelectedAccordionId] = useState();

  // * State  for "SetDisplayCollectionMyQueryOrDocument"
  const myQueryState = useSelector(
    (state) => state.SetDisplayCollectionMyQueryOrDocument
  ).myQuery;
  const collectionState = useSelector(
    (state) => state.SetDisplayCollectionMyQueryOrDocument
  ).collection;
  const documentState = useSelector(
    (state) => state.SetDisplayCollectionMyQueryOrDocument
  ).document;

  // * State for user database list
  const {
    response: dbListApiResponse,
    success: dbListApiSuccess,
    statusCode: dbListApiStatusCode,
    error: dbListApiError,
    loading: dbListApiLoading,
  } = useSelector((state) => state.dbListWithCollection);

  const [dbList, setDbList] = useState([]);

  // * Api call for database list
  useEffect(() => {
    dispatch(getDataBaseListWithCollection());
  }, [dispatch]);

  useEffect(() => {
    if (dbListApiResponse) setDbList(dbListApiResponse.data.list);

    if (dbListApiError) alert(dbListApiError.msg);
  }, [dbList, dbListApiSuccess, dbListApiError, dbListApiResponse]);

  // ! If refresh token invalid
  useEffect(() => {
    if (dbListApiStatusCode === 401) {
      dispatch(setRefreshTokenInValid()); // ? Common set refresh toke invalid
      dispatch(setDisplayAlertForRefreshInValid()); // ? Common display alert
      dispatch(setDefault_GetDatabaseList()); // ? [Specific]
      navigate("/login");
      window.location.reload(); // # Reloading the page to reset the application state.
    }
  }, [dispatch, navigate, dbListApiStatusCode]);

  return (
    <>
      <div className="flex flex-wrap mt-16">
        {/* Database &  Collection list */}
        <div
          className={`basis-full sm:basis-2/5 md:basis-2/6 lg:basis-1/4 xl:basis-1/5 max-h-[70vh]  sm:max-h-screen overflow-auto ${bgCardDynamic} shadow-inherit pb-10  `}
        >
          {/* Header */}
          <div className=" flex justify-center items-center  bg-Brand-Color ">
            <div className="">
              <img src={logo} alt="" className=" h-20 w-20" />
            </div>
            <div className="">
              <h1 className=" text-white/95 font-extrabold text-lg ">
                JsonOnClouds
              </h1>
            </div>
          </div>

          {/* My Queries */}
          <div
            className={` ${
              myQueryState ? " bg-[#ffa20044] " : ""
            } flex items-center space-x-2  px-3 py-2 text-Brand-Color  mt-4 cursor-pointer select-none`}
          >
            <i className="ri-braces-fill"></i>
            <h4
              onClick={() => dispatch(displayMyQuery())}
              className="text-base font-semibold font-serif select-none"
            >
              My Queries
            </h4>
          </div>

          {/*  Databases Create  and refresh*/}
          <div className={` ${textColorDynamic}  my-2 `}>
            {/* Create database manually */}
            <div
              className={` flex items-center justify-between py-1 hover:bg-gray-200 hover:text-black  md:cursor-pointer px-3`}
            >
              {/* Databases heading */}
              <div className=" flex space-x-2 items-center ">
                <i className="ri-database-2-fill"></i>
                <h4 className=" text-sm font-bold  font-sans select-none">
                  Databases
                </h4>
              </div>
              {/* Create features */}
              <div className=" flex space-x-1 items-center">
                <button
                  onClick={() => {
                    dispatch(getDataBaseListWithCollection());
                  }}
                  className=" w-6 h-6 flex justify-center items-center rounded-full hover:bg-[#ffa2008e] "
                >
                  <i className="ri-loop-right-fill font-extrabold"></i>
                </button>
                <div className=" w-6 h-6 flex justify-center items-center rounded-full hover:bg-[#ffa2008e] ">
                  <Suspense
                    fallback={RenderLoadingSpinnerInImageTag("w-1/4", "h-1/4")}
                  >
                    <CreateCollectionOrDatabaseModal
                      key={CreateUniqId(
                        "Dashboard-",
                        "-CreateCollectionOrDatabaseModal-ForDatabase"
                      )}
                      uiBtn={<i className="ri-add-fill font-extrabold"></i>}
                      createType={`Database`}
                    />
                  </Suspense>
                </div>
              </div>
            </div>
          </div>

          {/* Database list Accordion */}
          {dbListApiLoading ? (
            <p
              className={`${
                darkModeState ? "text-white" : "text-black/90"
              } font-bold text-lg text-center`}
            >
              Db list Lodging...
            </p>
          ) : (
            ""
          )}
          <Suspense
            fallback={
              <p
                className={`${
                  darkModeState ? "text-white" : "text-black/90"
                } font-bold text-lg text-center`}
              >
                Lodging...
              </p>
            }
          >
            {dbList.length
              ? dbList.map((item, index) => (
                  <AccordionDataBaseList
                    key={CreateUniqId(
                      "Dashboard-",
                      `-AccordionDataBaseList-${index}`
                    )}
                    database={item.database}
                    collectionArr={item.collectionArr}
                    databaseId={item.database_id}
                    id={index}
                    _selected={selectedAccordionId}
                    _setSelected={setSelectedAccordionId}
                  />
                ))
              : ""}
          </Suspense>

          {/* If database list is null */}
          {!dbListApiLoading && !dbList.length ? (
            <>
              <p
                className={`${
                  darkModeState ? "text-white" : "text-black/90"
                } font-bold text-sm  text-center px-2`}
              >
                <span className=" text-lg">
                  You don't save any databases right now!
                </span>{" "}
              </p>
            </>
          ) : (
            ""
          )}
        </div>

        {/* Database &  Collection Details */}
        <div
          className={` ${backGroundDynamic}  basis-full sm:basis-3/5 md:basis-2/3 lg:basis-3/4 xl:basis-4/5 min-h-screen max-h-screen`}
        >
          {/* When myQuery has selected in "Database and collection details"  */}
          {myQueryState ? (
            <Suspense
              fallback={RenderLoadingSpinnerInImageTag("w-1/4", "h-1/4")}
            >
              <OnSelectMyQueries />
            </Suspense>
          ) : (
            <></>
          )}

          {/* When Database has selected in "Database and collection details"  */}
          {collectionState ? (
            <Suspense
              fallback={RenderLoadingSpinnerInImageTag("w-1/4", "h-1/4")}
            >
              <OnSelectDatabase />
            </Suspense>
          ) : (
            <></>
          )}

          {/* When Collection  has selected in "Database and collection details"  */}

          {documentState ? (
            <Suspense
              fallback={RenderLoadingSpinnerInImageTag("w-1/4", "h-1/4")}
            >
              <OnSelectDocument />
            </Suspense>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};
